import { Box, ITheme, SvgIcon, Typography, useTheme } from '@mui/material';
import React from 'react';

export interface IPortfolioPerformanceItemProps{
    name: string;
    icon: React.FunctionComponent<React.SVGProps<SVGSVGElement> & {title?: string | undefined;}>;
    value: string;
}
const PortfolioPerformanceItem: React.FC<IPortfolioPerformanceItemProps> = ({ name, icon, value}) => {
    const theme = useTheme() as ITheme;
    return <Box display={"flex"} flexDirection={"column"} flexBasis={"45%"} flexGrow={1} gap={"7px"}>
        <Typography fontSize={"14px"} fontWeight={"400"} lineHeight={"17.07px"}>{name}</Typography>
        <Box display={"flex"} gap={"10px"} alignItems={"center"}>
            <SvgIcon component={icon} sx={{ color: theme.palette.primary.dark, width: "19px", height: "19px" }} inheritViewBox />
            <Typography fontSize={"20px"} fontWeight={"600"} lineHeight={"24.38px"}>{value}</Typography>
        </Box>
    </Box>
}

export default PortfolioPerformanceItem;